import { render } from "./MainFooter.vue?vue&type=template&id=9536862a&scoped=true"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=9536862a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9536862a"]])

export default __exports__